"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Banner_1 = __importDefault(require("./Banner"));
const Page = ({ children, page, noPadding }) => ((0, jsx_runtime_1.jsxs)("div", { id: "Page", children: [(page.headerImage || page.headerText) && (0, jsx_runtime_1.jsx)(Banner_1.default, { page: page }), (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('page-container', {
                'p-0': noPadding,
                'is-auth': _.includes(page.url, 'auth'),
            }), children: children })] }));
exports.default = Page;
